import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {Tabs, Tooltip, Icon, Badge} from 'antd';
import ProgressForTable from './ProgressForTable.js';
import ProgressForDashboard from '../dashboard/ProgressForDashboard';

class SystemUsageVMDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vmDetail: {},
            ctList: [],
            showHostName: ''
        };
    }

    componentDidMount() {
        const { vmData, ctData, showHostName } = this.props;
        this.loadData(vmData, ctData, showHostName);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.showHostName && this.state.showHostName !== nextProps.showHostName) {
            const vmData = nextProps.vmData;
            const ctData = nextProps.ctData;
            const showHostName = nextProps.showHostName;
            this.loadData(vmData, ctData, showHostName);
        }
    }

    loadData = (vmData, ctData, showHostName) => {
        let vmDetail = {
            hostName: '',
            ip: '',
            cpu: '',
            memory: '',
            disk: '',
            container: [],
            alert: [],
            containerAlert: []
        };
        for (let i = 0; i < vmData.length; i++) {
            if (vmData[i].hostName === showHostName) {
                vmDetail = vmData[i];
                break;
            }
        }
        let ctList = [];
        for (let i = 0; i < vmDetail.container.length; i++) {
            for (let j = 0; j < ctData.length; j++) {
                if (vmDetail.container[i] === ctData[j].containerID) {
                    ctList.push(ctData[j]);
                }
            }
        }

        this.setState({
            vmDetail: vmDetail,
            ctList: ctList,
            showHostName: showHostName
        });
    }

    progressCPUFormat = (cell, row) => {
        return <ProgressForTable percent={cell} level={row.cpuLevel}/>
    }

    progressMemoryFormat = (cell, row) => {
        return <ProgressForTable percent={cell} level={row.memoryLevel}/>
    }

    alertCountFormatter = (cell, row) => {
        const listItems = row.alert.map((item) =>
            <small key={item}>{item}</small>
        );
        const tips = (<div style={{display: 'grid'}}>{listItems}</div>);
        return (
            <div>
                <div style={{textAlign: 'center', color: '#D11C23', display: cell > 0 ? 'block' : 'none'}}>
                    <Tooltip title={tips}>
                        {cell}
                    </Tooltip>
                </div>
                <div style={{textAlign: 'center', display: cell > 0 ? 'none' : 'block'}}>
                    {cell}
                </div>
            </div>
        )
    }

    createCustomToolBar = props => {
        return (
            <div>
                <div className='searchFiled'>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    serviceStatusFormatter = (cell, row) => {
        return (
            <div style={{textAlign: 'center'}}>
                <Badge status={row.serviceStatus === 'passing' ? 'success' : 'error'}/>
            </div>
        )
    }

    serviceNameFormatter = (cell, row) => {
        const tp = (
            <Tooltip title="Container Type">
                <Icon type="question-circle-o"/>
            </Tooltip>
        );
        const showServiceName = row.serviceName === '' ? row.containerType : row.serviceName;
        const tips = row.serviceName === '' ? tp : '';
        return (
            <div>
                {showServiceName} {tips}
            </div>
        )
    }

    doPin = () => {
        this.props.doPin();
    }

    doUnpin = () => {
        this.props.doUnpin();
    }

    render() {
        const vmDetail = this.state.vmDetail;
        const ctList = this.state.ctList;

        const options = {
            defaultSortName: 'serviceName',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            noDataText: 'No container found.',
            searchDelayTime: 500
        };
        const alerts = this.state.vmDetail.alert;
        const containerAlert = this.state.vmDetail.containerAlert;
        let alert4show = '';
        if ((alerts && alerts.length) > 0 || (containerAlert && containerAlert.length > 0)) {
            const listItems = alerts.map((item) =>
                <small key={item}>{item}</small>
            );
            alert4show = (
                <div style={{display: 'grid'}}>
                    {listItems}
                    <small style={{display: containerAlert.length > 0 ? 'block' : 'none'}}>Container Alert : {containerAlert.length}</small>
                </div>);
        }

        return (
            <div className="page-system-usage-detail">
                <div>
                    <div className="panel-body">
                        <div className="form-group">
                            <b className="tenant-name">{vmDetail.hostName}&nbsp;
                                <div style={{display: (alerts && alerts.length) > 0 || (containerAlert && containerAlert.length > 0) ? 'inline-block' : 'none'}}>
                                    <Tooltip title={alert4show}>
                                        <Icon type="exclamation-circle"/>
                                    </Tooltip>
                                </div>
                            </b>
                            <div className="system-usage-detail-pin">
                                <div className="system-usage-detail-icon-pin" style={{display: vmDetail.pinned ? 'block' : 'none'}} onClick={this.doUnpin}>
                                    <Tooltip title='Unpin'>
                                        <Icon type="pushpin"/>
                                    </Tooltip>
                                </div>
                                <div className="system-usage-detail-icon-unpin" style={{display: vmDetail.pinned ? 'none' : 'block'}} onClick={this.doPin}>
                                    <Tooltip title='Pin to dashboard'>
                                        <Icon type="pushpin"/>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="ip-address">{vmDetail.ip}</div>
                        </div>
                        <div className="system-usage-detail-content">
                            <div className="system-usage-detail-dashboard">
                                <ProgressForDashboard percent={vmDetail.cpu} level={vmDetail.cpuLevel} type='CPU'/>
                            </div>
                            <div className="system-usage-detail-dashboard">
                                <ProgressForDashboard percent={vmDetail.memory} level={vmDetail.memoryLevel} type='Memory'/>
                            </div>
                            <div className="system-usage-detail-dashboard">
                                <ProgressForDashboard percent={vmDetail.disk} level={vmDetail.diskLevel} type='Disk'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Tabs type="card">
                        <Tabs.TabPane tab={<span>{ctList.length} Containers</span>} key="2">
                            <div>
                                <BootstrapTable data={ ctList } search={ true } options={ options } striped hover condensed>
                                    <TableHeaderColumn dataField='serviceStatus' dataSort={ true } dataFormat={this.serviceStatusFormatter} width="7%">Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='serviceName' dataSort={ true } dataFormat={this.serviceNameFormatter} width="23%">Service Name</TableHeaderColumn>
                                    <TableHeaderColumn dataField='alertCount' dataSort={ true } dataFormat={this.alertCountFormatter}  width="8%">Alerts</TableHeaderColumn>
                                    <TableHeaderColumn dataField='cpu' dataSort={ true } dataFormat={ this.progressCPUFormat } width="19%">CPU</TableHeaderColumn>
                                    <TableHeaderColumn dataField='memory' dataSort={ true } dataFormat={ this.progressMemoryFormat } width="19%">Memory</TableHeaderColumn>
                                    <TableHeaderColumn dataField='containerID' isKey dataSort={ true } width="24%" columnTitle>Container ID</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                <div className="page-close" onClick={this.props.close}>
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                </div>
            </div>
        );
    }
}

export default SystemUsageVMDetail;


// WEBPACK FOOTER //
// ./src/modules/system-usage/SystemUsageVMDetail.js